import { getCurrencyCodeBySymbol as n } from "./getCurrencyCodeBySymbol.mjs";
import { CURRENCY_SYMBOL_TO_CODE as i } from "./moneyUtils.consts.mjs";
const m = Object.keys(i).join(""), g = (e, r) => {
  if (!e)
    return r;
  const o = new RegExp(`[${m}]`, "g").exec(String(e)), t = o ? o[0] : void 0;
  return t && n(t, r) || r;
};
export {
  g as getCurrencyCodeFromString
};
//# sourceMappingURL=getCurrencyCodeFromString.mjs.map
